export const isVideoView = (view) =>
  !!view && (view.slice(0, 2) === "v_" || view.startsWith("video"))

export const isJ3dView = (view) => !!view && view.startsWith("j3d")

export const isTgaiView = (view) => view?.startsWith("tgai_")
